import React, { memo } from 'react'

import Loading from '@/src/components/Loading'
import ButtonGroup from '@/src/components/Pagination/ButtonGroup'
import usePagination from '@/src/components/Pagination/usePagination'
import RTKQueryErrorMessages from '@/src/components/RTKQueryErrorMessages/RTKQueryErrorMessages'

import Installation from '../../../headlessComponents/Installation'

import PostRow from './PostRow'

const PostList: React.FC = memo(() => {
  const { data, error, isLoading, page, totalPage } = usePagination(15)

  if (error) {
    return <RTKQueryErrorMessages error={error} />
  }

  if (isLoading || data === undefined) {
    return <Loading />
  }

  if (data.postList.length === 0) {
    return <Installation />
  }

  return (
    <section className="flex h-full flex-col justify-between">
      <ul className="post-row-container">
        {data.postList?.map((post: Post, i: number) => {
          return <PostRow key={i} post={post} index={i} />
        })}
      </ul>
      <ButtonGroup page={page} totalPage={totalPage} />
    </section>
  )
})
PostList.displayName = 'PostList'

export default PostList
